import {
  AuthState,
  UnauthenticatedProfile,
  UnverifiedUserProfile,
  UserProfile,
} from '../../../types/AuthTypes';

export const isUnverifiedUser = (
  user: AuthState['user']['data'],
): user is UnverifiedUserProfile => {
  if (!user) {
    return false;
  }
  return (user as UnverifiedUserProfile).isUnverified;
};

export const isUnauthenticatedUser = (
  user: AuthState['user']['data'],
): user is UnauthenticatedProfile => {
  if (!user) {
    return false;
  }
  return (user as UnauthenticatedProfile).isUnauthenticated;
};

export const isVerifiedUser = (user: AuthState['user']['data']): user is UserProfile => {
  if (!user) {
    return false;
  }
  return !isUnverifiedUser(user) && !isUnauthenticatedUser(user);
};
